import React, { useEffect } from "react";
import {
  Icon,
  Button,
  Col,
  RSelect,
} from "../../components/Component";
import {
  Modal,
  ModalBody,
  Form
} from "reactstrap";
import { useForm } from "react-hook-form";
import { filterStatus } from "../../service/Data";
import { handlePostApis } from "../../service/Api";
import Cookies from 'js-cookie'

const FormModal = ({modal,closeModal, fetchCategory, formData, setFormData, modalType}) => {
  
  useEffect(() => {
    reset(formData)
  }, [formData]);
  const { reset, register, handleSubmit, formState: { errors } } = useForm();
  const token = Cookies.get('authToken');
const headers = {
    Authorization: `Bearer ${token}`
  };
  const handleTdDataPost = () => {
    const data = {
      name: formData?.name,
      slug: formData?.slug
    }
    const {name,slug } = formData
    if (!name || !slug) {
      return;
    }
    else {
      const res = handlePostApis(`admin/add/category`, data)
    res.then(function (result) {

      if (result) {
        alert(result.data.message)
        closeModal();
        fetchCategory();
      }
    })
    }
  }
  // Traveldeals Update
  const handleUpdateTravelDeals = () => {
    const data = {
      id: formData.id,
      name: formData.name,
      slug: formData.slug,
      is_active: formData.is_active
    }
    const res = handlePostApis(`admin/update/category`, data)
    res.then(function (result) {
      console.log(result)
      if (result) {
        alert(result.data.message)
        fetchCategory();
        closeModal();
      }
    })
  }

  console.log(formData,'formblog');
  
  return (
    <Modal isOpen={modal} toggle={() => closeModal()} className="modal-dialog-centered" size="lg">
        <ModalBody>
          <a
            href="#cancel"
            onClick={(ev) => {
              ev.preventDefault();
              closeModal();
            }}
            className="close"
          >
            <Icon name="cross-sm"></Icon>
          </a>
          <div className="p-2">
            <h5 className="title">{modalType === "add" && "Add Category"} {modalType === "edit" && "Update Category"}</h5>
            <div className="mt-4">
                      <Form className="row gy-4" onSubmit={handleSubmit(() => {
              modalType === 'add' ? handleTdDataPost() : handleUpdateTravelDeals();
            })}>
                   
                <Col md="6">
                  <div className="form-group">
                    <label className="form-label">Name</label>
                    <input
                      type="text"
                      {...register('name', { required: "This field is required" })}
                      value={formData.name}
                      placeholder="Enter name"
                      onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                      className="form-control" />
                    {errors.name && <span className="invalid">{errors.name.message}</span>}
                  </div>
              </Col>
                <Col md="6">
                  <div className="form-group">
                    <label className="form-label">Slug</label>
                    <input
                      type="text"
                      {...register('slug', { required: "This field is required" })}
                      value={formData.slug}
                      placeholder="Enter slug"
                      onChange={(e) => setFormData({ ...formData, slug: e.target.value })}
                      className="form-control" />
                    {errors.slug && <span className="invalid">{errors.slug.message}</span>}
                  </div>
                          </Col>
                         
               
                <Col md="12">
                    <div className="form-group">
                      <label className="form-label">Status</label>
                      <div className="form-control-wrap">
                        <RSelect
                          options={filterStatus}
                          value={{
                            value: formData.is_active,
                            label: formData.is_active ? "True" : "False",
                          }}
                          onChange={(e) => setFormData({ ...formData, is_active: e.value })}
                        />
                      </div>
                    </div>
                  </Col>
                <Col size="12">
                  <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                    <li>
                    <Button color="primary" size="md" type="submit">
                        {modalType === "add" && "Submit"} {modalType === "edit" && "Submit"}
                      </Button>
                    </li>
                    <li>
                      <Button
                        onClick={(ev) => {
                          ev.preventDefault();
                          closeModal();
                        }}
                        className="link link-light"
                      >
                        Cancel
                      </Button>
                    </li>
                  </ul>
                </Col>
              </Form>
            </div>
          </div>
        </ModalBody>
      </Modal>
  );
};
export default FormModal;
